$(document).ready(function() {

  if (window.location.pathname === "/products") {
        window.location.href = "/collections/all";
    } else if (window.location.pathname === "/products/") {
        window.location.href = "/collections/all";
    } else if (window.location.pathname === "/account/register") {
        window.location.href = "/account/login";
    }

  
  $('.custom_addtocart_btn').click(function(x) {
      document.querySelector(".product-form__submit.button.button--full-width.button--primary").click();
  });


  // Get the cart link element by its id
    var $cartIcon = $('.header__icon--cart ');
    var $footerCartIcon = $('.footer-block__details-content a[href="/cart"]');

    // Function to add the 'active' class to the cart link
    function addActiveClass() {
        $cartIcon.addClass('active');
        $footerCartIcon.addClass('list-menu__item--active');
    }

    // Function to remove the 'active' class from the cart link
    function removeActiveClass() {
        $cartIcon.removeClass('active');
        $footerCartIcon.removeClass('list-menu__item--active');
    }

    // Check the current page URL to add the 'active' class only when you're on the cart page
    if (window.location.pathname === '/cart') {
        addActiveClass();
    } else {
        removeActiveClass();
    }

    // Add event listener to the cart icon for click
    $cartIcon.on('click', function() {
        addActiveClass(); // Add the 'active' class when the cart icon is clicked
    });

    // Listen for navigation events (for single-page applications using history API)
    $(window).on('popstate', function() {
        if (window.location.pathname === '/cart') {
            addActiveClass();
        } else {
            removeActiveClass();
        }
    });

  $('.product-card-wrapper .quick-add').click(function(event) {
      event.preventDefault();
      event.stopPropagation();
      var productURL = $(this).attr('data-url');
      window.location.href = productURL;
  });  

  if($('body').hasClass('template-product')) {
    $(window).on('scroll', function() {
      $('.product-card-wrapper .quick-add').click(function(event) {
          event.preventDefault();
          event.stopPropagation();
          var productURL = $(this).attr('data-url');
          window.location.href = productURL;
      });
    });
  }

  if(document.querySelector('.search-bar')) {
    document.querySelector('.search-bar').addEventListener('input', function(event) {
        event.preventDefault();
        let query = this.value.toLowerCase().trim(); // Get the search query in lowercase and trim spaces
        // Select both product containers: .grid__item and .article
        let products = document.querySelectorAll('.grid__item, .article');
    
        products.forEach(function(product) {
            let productName = product.querySelector('.full-unstyled-link').textContent.toLowerCase(); // Get product name
    
            // Check if the product name includes the search query
            if (productName.includes(query)) {
                product.style.display = 'block'; // Show the matching product
            } else {
                product.style.display = 'none'; // Hide the non-matching product
            }
        });
    });
  }
  



  if($('body').hasClass('your-shopping-cart')) {

    const checkoutButton = $('#checkout');
    const dynamicCheckoutButton = $('.cart__dynamic-checkout-buttons');
    
    // Function to check cart quantity
    function checkCartQuantity() {
      $.getJSON('/cart.js')
        .done(function(cart) {
          const totalQuantity = cart.items.reduce((total, item) => total + item.quantity, 0);

          // Disable checkout button if total quantity is less than 2
          if (totalQuantity < 2) {
            checkoutButton.css({ opacity: '0.5', pointerEvents: 'none' });
            dynamicCheckoutButton.hide();
            alert('You need at least 2 items in your cart to proceed to checkout.');
          } else {
            checkoutButton.css({ opacity: '1', pointerEvents: 'auto' });
            dynamicCheckoutButton.show();
          }
        })
        .fail(function() {
          console.error('Failed to fetch cart data.');
        });
    }

    // Check cart quantity on page load
    checkCartQuantity();
    
    function handleCartUpdate() {
      $.getJSON('/cart.js')
        .done(function(data) {
          const cartCount = data.item_count;
          console.log(`Cart count: ${cartCount}`);
          $('.cart-count-bubble > span[aria-hidden="true"]').text(cartCount);
          checkCartQuantity();
        })
        .fail(function(error) {
          console.error('Error fetching cart count:', error);
      });
    }
  
    if (window.fetch) {
      const originalFetch = window.fetch;
      window.fetch = function() {
        return originalFetch.apply(this, arguments).then(response => {
          if (arguments[0].includes("/cart/")) {
            handleCartUpdate();
          }
          return response;
        });
      };
    }
  
    if (window.XMLHttpRequest) {
      const originalOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(method, url) {
        if (url.includes("/cart/")) {
          this.addEventListener("load", handleCartUpdate);
        }
        originalOpen.apply(this, arguments);
      };
    }
  
    }
      
  
});






document.addEventListener('DOMContentLoaded', () => {
    const accountIcon = document.querySelector('.header__icon--account');

    // Check if the element exists to avoid errors
    if (accountIcon) {
        if (window.location.pathname === '/account/login') {
            accountIcon.classList.add('active');
        } else {
            accountIcon.classList.remove('active');
        }
    } else {
        console.error('Element with class .header__icon--account not found.');
    }


  const accountIcon1 = document.querySelector('.header__icon--account');

    // Check if the element exists to avoid errors
    if (accountIcon1) {
        if (window.location.pathname === '/account') {
            accountIcon1.classList.add('active');
        } else {
            accountIcon1.classList.remove('active');
        }
    } else {
        console.error('Element with class .header__icon--account not found.');
    }




  const eyeBtn = document.getElementById('eye-btn');
  const passwordField = document.getElementById('CustomerPassword');

  if(eyeBtn) {
      eyeBtn.addEventListener('click', () => {
        eyeBtn.classList.toggle("active");
        // Toggle the input type between password and text
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
        } else {
          passwordField.type = 'password';
        }
    });
  }
  








  

  
});




